import React from "react";
import "./About.css";
import profilePic from "../../images/Github-profile-pic.png";
import Navbar from "../Shared/Navbar";
import Typical from "react-typical";
import Footer from "../Home/Footer/Footer";

const About = () => {
  return (
    <main id="aboutpage">
      <Navbar />
      <div
        className="container-fluid about-container"
        style={{ maxWidth: "1300px", margin: "auto" }}
      >
        <div className="row px-1">
          <div className="col-md-6 col-sm-12 ml-3">
            {/* <img className="profile mb-4" src={profilePic} alt="" /> */}
            <h3 className="headline ">
              <span> I am </span>
              <span className="animated-text">
                <Typical
                  loop={Infinity}
                  wraper=""
                  steps={[
                    " Jahidul Islam",
                    1000,
                    " Software Engineer 💻",
                    1000,
                    "Frontend Developer 💻",
                    1000,
                    "Backend Developer ❤️",
                    1000,
                    "Full-Stack Web Developer 📱",
                    1000,
                    "MERN Stack Developer 💻",
                    1000,
                  ]}
                />
              </span>
            </h3>
            <p className="text-justify aboutpage-text">
              I am a highly motivated Full Stack Web Developer (MERN Stack) with
              3+ years of experience designing and building responsive,
              high-performance websites and web applications. Proficient in
              HTML, CSS, JavaScript, React, Node.js, and Express.js, with a
              strong grasp of SEO best practices, business analysis, and product
              planning to help products reach and engage the right audience.
              Skilled in building RESTful APIs, multi-vendor e-commerce
              platforms, admin dashboards, and secure online payment
              integrations. Proficient in writing clean, well-documented, and
              scalable code. Committed to staying up-to-date with the latest
              technologies and trends in web development. Looking to join a
              dynamic organization where I can apply my technical knowledge and
              problem-solving skills to contribute to the success of the company
              and take on new challenges.
            </p>

            <div className="contact-details">
              <h2 style={{ color: "#00ffd5" }}>Contact Details</h2>
              <p className="address aboutpage-text">
                <div style={{ whiteSpace: "pre-wrap" }}>
                  <div>
                    <strong className="left-column">
                      {" "}
                      <span>&bull;</span> Name
                    </strong>{" "}
                    : Md Jahidul Islam <br />
                  </div>
                  <div>
                    <strong className="left-column">
                      {" "}
                      <span>&bull;</span> Location
                    </strong>{" "}
                    : Dhaka, Bangladesh <br />
                  </div>
                  <div>
                    <strong className="left-column">
                      {" "}
                      <span>&bull;</span> Languages
                    </strong>{" "}
                    : English, Bengali <br />
                  </div>
                  <div>
                    <strong className="left-column">
                      {" "}
                      <span>&bull;</span> Full-time
                    </strong>{" "}
                    : preferred <br />
                  </div>
                  <div>
                    <strong className="left-column">
                      {" "}
                      <span>&bull;</span> Freelance
                    </strong>{" "}
                    : Available <br />
                  </div>
                  <div>
                    <strong className="left-column">
                      {" "}
                      <span>&bull;</span> Mobile
                    </strong>{" "}
                    : +880 1938901990 <br />
                  </div>
                  <div>
                    <strong className="left-column">
                      {" "}
                      <span>&bull;</span> Email{" "}
                    </strong>{" "}
                    : za0162hid@gmail.com <br />
                  </div>
                </div>
              </p>
            </div>
          </div>
          <div className="col-md-5 col-sm-12 ml-3 mt-2">
            <h4>
              {" "}
              <span style={{ color: "#00ffd5" }}>TECHNICAL SKILLS </span>
            </h4>
            <div className="skills">
              {/* <div className="language">
                                <h6> <span className="language-headline"> LANGUAGES </span></h6>
                                <div className="language-skills my-2 pb-3">
                                 <span> JavaScript </span> 
                                    <span> ES6 </span>
                                    <span> Python </span> 
                                    <span> HTML </span>
                                    <span> CSS</span>
                                </div>
                                    
                                    
                            </div>

                            <div className="framework">
                                <h6> <span className="framework-headline"> FRAMEWORK </span> </h6>
                                <div className="framework-skills my-2 pb-3">
                                <span> React </span> 
                                <span> Express.jS </span> 
                                <span> Django </span>
                                <span> Material-ui </span>
                                <span> Bootstrap </span>
                                <span> React-Bootstrap </span>
                                </div>
                                
                                
                            </div>

                            <div className="databases">

                                <h6> <span className="databases-headline"> DATABASES </span> </h6>
                                <div className="databases-skills my-2 pb-3">
                                <span> MongoDB </span>
                                <span> MySQL</span>
                                <span> PostgreSQL </span>
                                </div>
                                
                                
                            </div>

                            <div className="os">
                                <h6> <span className="os-headline"> OS Platforms </span> </h6>
                                <div className="os-skills my-2 pb-3">
                                <span> Windows </span>
                                <span> Kali Linux </span>
                                </div>
                                
                                    
                            </div>

                            <div className="deployment">
                                <h6> <span className="deployment-headline"> DEPLOYMENT </span> </h6>
                                    <div className="deployment-skills my-2 pb-3">
                                    <span> Firebase Hosting </span> 
                                <span> Heroku </span>
                                <span> Netlify </span>
                                <span> Linux Shared Hosting Service </span>
                                    </div>
                                

                            </div>

                            <div className="others">
                                <h6> <span className="others-headline"> OTHERS </span> </h6>
                                <div className="others-skills my-2 pb-3">
                                <span> Node.js</span> 
                                <span> React Router  </span>
                                <span> Google Map </span>
                                <span> Stripe </span>
                                <span> Data Structure </span>
                                <span> Algorithm  </span>
                                </div>
                                

                            </div> */}

              <div className="language">
                <h5>
                  {" "}
                  <span className="language-headline"> Expertise </span>
                </h5>
                <div className="language-skills my-2 pb-3">
                  <span> React.js </span>
                  <span> Redux </span>
                  <span> Next.js </span>
                  <span> JavaScript </span>

                  <span> Node.js </span>
                  <span> Express.js </span>
                  <span> MongoDB </span>
                  <span> Firebase / Firestore </span>

                  <span> Tailwind CSS </span>
                  <span> Bootstrap </span>
                  <span> Material UI </span>
                  <span> Sass </span>

                  <span> HTML5 </span>
                  <span> CSS3 </span>
                  <span> RESTful APIs </span>
                  <span> Git & GitHub </span>
                </div>
              </div>

              <div className="framework">
                <h5>
                  {" "}
                  <span className="framework-headline"> Comfortable </span>{" "}
                </h5>
                <div className="framework-skills my-2 pb-3">
                  <span> WordPress (customization) </span>
                  <span> SSLCOMMERZ Payment </span>
                  <span> GraphQL </span>
                  <span> Postman </span>
                  <span> DigitalOcean </span>
                  <span> Heroku </span>
                  <span> Vercel </span>
                  <span> Render </span>
                  <span> Netlify </span>
                  <span> MongoDB Atlas </span>
                  <span> Adobe Photoshop </span>
                </div>
              </div>

              {/* <div className="databases">

                                <h5> <span className="databases-headline"> DATABASES </span> </h5>
                                <div className="databases-skills my-2 pb-3">
                                    
                                </div>


                            </div> */}

              <div className="os">
                <h5>
                  {" "}
                  <span className="os-headline"> OS Platforms </span>{" "}
                </h5>
                <div className="os-skills my-2 pb-3">
                  <span> macOS </span>
                  <span> Windows </span>
                  <span> Ubuntu </span>
                  <span> Kali Linux </span>
                </div>
              </div>

              <div className="familiar">
                <h5>
                  <span className="familiar-headline"> FAMILIAR </span>{" "}
                </h5>

                <div className="familiar-skills my-2 pb-3">
                  <span> On-page SEO </span>
                  <span> Business Requirement Analysis </span>
                  <span> QR Code Integration </span>
                  <span> Agile Development </span>
                </div>
              </div>
            </div>

            {/* I
                        have completed two long term course on "Python and Django Full Stack Web
                        Development" from Udemy and "Complete Web Development Course With
                        Jhankar Mahbub" from Programming Hero.  */}
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
};

export default About;
